<div class="field-option">
  @if (queryFieldSearch.enabled) {
    <div class="select-search-field">
      <select-search-api
        (selectionChange)="setSelectedSearchField($event)"
        [allowAccountSelection]="false"
        [classes]="'fill'"
        [fetchData]="fetchData"
        [placeholder]="'Search fields'"
        [value]="selectedOption">
      </select-search-api>
    </div>
  } @else if (fieldOptions) {
    <div class="select-search-field">
        <select-filter
          (constant_changed)="setSelectedField($event);"
          [modelValue]="value"
          [options]="fieldOptions"
          [class]="'select-filter-inline fill'">
        </select-filter>
    </div>
  }
</div>
